import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import ExpandLessIcon from "assets/icons/ExpandLessIcon";
import ExpandMoreIcon from "assets/icons/ExpandMoreIcon";

import { memo, useState } from "react";

import invoicePattenItems from "assets/js/invoicePattenItems";
// import TextInput from "components/Input/TextInput";

const FactorSettingInfoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  // justifyContent: 'space-between'
}));

const StyledListItemButton = styled(ListItemButton)(
  ({ theme, active }: { theme?: ThemeObjType; active?: boolean }) => ({
    height: "50px",
    margin: "8px 0 8px 0",
    padding: "12px",
    backgroundColor: active ? "none" : "#F9FBFC",
    "&:hover": {
      backgroundColor: "#EBF0FF52",
    },
  })
);

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "30px",
});

const StyledListItemText = styled(ListItemText)({
  textAlign: "right",
});

const InfoItem = memo(({ data }: { data: (typeof invoicePattenItems)[0] }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { Icon, ChildComponent } = data;
  return (
    <>
      <StyledListItemButton disableRipple active={!open} onClick={() => setOpen(!open)}>
        <StyledListItemIcon>
          <Icon active={open} />
        </StyledListItemIcon>
        <StyledListItemText>
          <Typography
            variant="body2"
            color={open ? theme.palette.text.primary : theme.palette.text.secondary}
          >
            {data.title}
          </Typography>
        </StyledListItemText>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </StyledListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <ChildComponent />
      </Collapse>
    </>
  );
});

const FactorSettingPatternList = () => {
  const initialValues = {
    value: "",
  };

  const onSubmit = (values: typeof initialValues) => {};

  const theme = useTheme();

  return (
    <FactorSettingInfoContainer>
      {/* @ts-ignore */}
      <List component="div" disablePadding>
        {invoicePattenItems.map((item, index) => (
          <InfoItem key={index} data={item} />
        ))}
      </List>
    </FactorSettingInfoContainer>
  );
};

export default FactorSettingPatternList;
